module.exports = __webpack_public_path__ + "static/media/proj20_img12.5134d006.jpg";